enum PaginationDirection {
  BiDirectional = 'BiDirectional',
  Forward = 'Forward',
  Reverse = 'Reverse'
}
export default PaginationDirection
